export const SERVICELIST = "CATEGORYLIST"
export const SERVICEADD = "SERVICEADD"
export const SERVICECATEGORYLIST ="SERVICECATEGORYLIST"
export const SERVICEDETAILS =  "SERVICEDETAILS"
export const SERVICESTATUS =  "SERVICESTATUS"

